<template>
  <div id="partner">
    <a v-for="(item ,index) in partnerList"
       :key="index"
       :href="item.link"
       target="_blank">
      <div class="enterprise">
        <img :src="'https://api.obtdata.com/orbita_cloud/resource/file/' + item.logoUuid">
        <p>{{item.name}}</p>
      </div>
    </a>
  </div>
</template>

<script>
import { getCooperator } from '@/api/cooperation'
export default {
  data () {
    return {
      partnerList: [],
    }
  },
  mounted () {
    this.getPartner();
  },
  methods: {
    //获取合作伙伴
    async getPartner () {
      const res = await getCooperator()
      const resData = res.data
      if (resData.code === 200) {
        this.partnerList = resData.data
      }
    }
  }

}
</script>

<style scoped>
#partner {
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
}
#partner img {
  margin: 0 auto;
  display: block;
  color: #333333;
}
#partner p {
  line-height: 25px;
  font-size: 14px;
  color: #666;
}
a:link,
a:visited {
  outline: 0;
  text-decoration: none;
}
a,
a:visited {
  color: #333;
}
a,
button,
input {
  outline: none;
}
a {
  cursor: pointer;
  width: 25%;
  display: inline-block;
}
a,
div,
img,
p {
  margin: 0;
  padding: 0;
  border: 0;
  font-family: Microsoft YaHei;
  box-sizing: border-box;
}
.enterprise {
  width: 100%;
  padding: 0 20px;
  margin: 15px 0;
  overflow: hidden;
}
.enterprise img {
  width: 80%;
  background-color: #fff;
  cursor: pointer;
}
.enterprise p {
  margin-top: 20px;
  text-align: center;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
@media only screen and (max-width: 540px) {
  .enterprise {
    width: 100%;
  }
  a {
    width: 50%;
  }
}
</style>
